import React, { createContext } from "react";
import { jwtDecode } from "jwt-decode";
import getToken from "../functions/get-token";
import axios from "../requests/axios.js";

function getUserFromStorage() {
  const token = getToken(false);
  try {
    return jwtDecode(token);
  } catch {
    return null;
  }
}

function useProviderAuth() {
  const [user, setUser] = React.useState(getUserFromStorage);
  const isAuthenticated = () => getUserFromStorage() !== null;

  const attemptLogin = (email, password) => {
    return new Promise((resolve, reject) => {
      axios
        .post("/api/users/login", { email, password })
        .then((response) => {
          const token = response.data.token_type + " " + response.data.token;
          window.localStorage.setItem("__bearer", token);

          setUser(getUserFromStorage());
          resolve(response);
        })
        .catch(reject);
    });
  };

  const logout = (cb) => {
    window.localStorage.clear();
    setUser(null);
    if (cb) {
      cb();
    }
  };

  return {
    user,
    logout,
    attemptLogin,
    isAuthenticated,
  };
}

const authContext = createContext({
  user: null,
  logout: () => null,
  attemptLogin: () => null,
  isAuthenticated: () => false,
});

export function useAuth() {
  return React.useContext(authContext);
}

export default function AuthProvider({ children }) {
  const auth = useProviderAuth();
  return <authContext.Provider value={auth}>{children}</authContext.Provider>;
}
